export { default as white } from './white'
export { default as teal } from './teal'
